import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '../App/Components'
import { useAppSelector } from '../App/Hooks/reduxHooks'
import { H1, H2 } from '../Common/Typography'

import {
  VideoContentWrapper,
  VideoDescription,
  VideoDescriptionWrapper,
} from './components/VideoCard/style'
import { VideoCard } from './components/VideoCard/VideoCard'
import { useGetWebinarListQuery } from './util/useWebinarQuery'

export const Webinars = () => {
  const establishmentLanguage = useAppSelector(
    state => state.establishment.active?.language,
  )

  const { data, status } = useGetWebinarListQuery(establishmentLanguage || '')
  const { t } = useTranslation()

  if (status === 'pending') return <Spinner />

  if (status === 'error') return <p>something went wrong</p>

  return (
    <div>
      <Box m={3} mb={1} p={2}>
        <H1> {t('Webinars')}</H1>
      </Box>
      <div>
        {data.map(webinar => {
          return (
            <VideoContentWrapper key={webinar.uuid} m={3} p={2}>
              <VideoCard
                bgImg={webinar.previewImage}
                videoUrl={webinar.videoUrl}
              />
              <VideoDescriptionWrapper>
                <H2 mb={3}>{webinar.name}</H2>
                <VideoDescription>{webinar.description}</VideoDescription>
              </VideoDescriptionWrapper>
            </VideoContentWrapper>
          )
        })}
      </div>
    </div>
  )
}
